export default "__VITE_ASSET__BUc0yl1l__"